import { render, staticRenderFns } from "./processDetails.vue?vue&type=template&id=76e0b74c&scoped=true&"
import script from "./processDetails.vue?vue&type=script&lang=js&"
export * from "./processDetails.vue?vue&type=script&lang=js&"
import style0 from "./processDetails.vue?vue&type=style&index=0&id=76e0b74c&scoped=true&lang=css&"
import style1 from "./processDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e0b74c",
  null
  
)

export default component.exports